export const VERSION = '4.2.0-rc.0';
export const ID = 'fa66018377f6514021e705f5cd47d4050e93e104';
export const DATE = '2023-06-05T21:03:29.286Z';
